import { TextValuesPayload } from '../../../../../store/inspectionForm/slice/inspectionFormSlice';
import { EmissionUnitInformation } from '../../../EmissionRequest';

export default function makeUnitInformation(
  textValues: TextValuesPayload,
): EmissionUnitInformation {
  return {
    licensePlate: textValues.licensePlate,
    color: '',
    serialVin: textValues.vinNumber,
    serialMotor: textValues.serialMotor,
    driverIsContractor: false,
  };
}
